import { gql } from '@apollo/client';

export const  REGISTER_MUTATION = gql`
  mutation Register($input: RegisterInput!) {
    register(input: $input) {
      token
      refreshToken
      user {
        id
        username
        phoneNumber
        email
        role
      }
    }
  }
`;

export const LOGIN_MUTATION = gql`
  mutation Login($input: LoginInput!) {
    login(input: $input) {
      token
      refreshToken
      user {
        id
        username
        email
        role
      }
    }
  }
`;

export const CREATE_USER = gql`
  mutation CreateUser(
    $username: String!
    $email: String!
    $password: String!
    $role: String!
    $profilePicture: String
    $phoneNumber: String
    $status: String
    $gender: String
  ) {
    createUser(
      username: $username
      email: $email
      password: $password
      role: $role
      profilePicture: $profilePicture
      phoneNumber: $phoneNumber
      status: $status
      gender: $gender
    ) {
      id
      username
      email
      role
      profilePicture
      phoneNumber
      status
      lastLogin
      twoFactorEnabled
      gender
      createdAt
      updatedAt
    }
  }
`;

export const UPDATE_USER = gql`
  mutation UpdateUser(
    $id: ID!
    $username: String
    $email: String
    $role: String
    $profilePicture: String
    $phoneNumber: String
    $lastLogin: String
    $twoFactorEnabled: Boolean
    $status: String
  ) {
    updateUser(
      id: $id
      username: $username
      email: $email
      role: $role
      profilePicture: $profilePicture
      phoneNumber: $phoneNumber
      lastLogin: $lastLogin
      twoFactorEnabled: $twoFactorEnabled
      status: $status
    ) {
      id
      username
      email
      role
      profilePicture
      phoneNumber
      status
      lastLogin
      twoFactorEnabled
      gender
      createdAt
      updatedAt
    }
  }
`;


export const DELETE_USER = gql`
  mutation DeleteUser($id: ID!) {
    deleteUser(id: $id)
  }
`;

//vendor mutation

export const UPDATE_VENDOR = gql`
  mutation UpdateVendor($vendorId: ID!, $input: VendorUpdateInput!) {
    updateVendor(vendorId: $vendorId, input: $input) {
      id
      userId
      businessName
      email
      phone
      address
      createdAt
    }
  }
`;

export const CREATE_VENDOR = gql`
  mutation CreateVendor($input: VendorInput!) {
    createVendor(input: $input) {
      id
      userId
      businessName
      email
      phone
      address
      createdAt
    }
  }
`;

export const DELETE_VENDOR = gql`
  mutation DeleteVendor($id: ID!) {
    deleteVendor(id: $id)
  }
`;

// shop mutation
export const CREATE_SHOP = gql`
  mutation CreateShop($input: ShopInput!) {
    createShop(input: $input) {
      id
      vendorId
      shopName
      shopLogo
      location {
       city
       country
       state
      }
      fromDate
      toDate
    }
  }
`;

export const UPDATE_SHOP = gql`
  mutation UpdateShop($shopId: ID!, $input: ShopUpdateInput!) {
    updateShop(shopId: $shopId, input: $input) {
      id
      shopName
      shopLogo
      location {
        city
        country
        state
      }
        fromDate
        toDate
    }
  }
`;

export const DELETE_SHOP = gql`
  mutation DeleteShop($id: ID!) {
    deleteShop(id: $id)
  }
`;

export const CREATE_ADDRESS = gql`
  mutation CreateAddress(
    $userId: ID!
    $addressLine1: String!
    $addressLine2: String
    $city: String!
    $state: String
    $country: String!
    $postalCode: String
    $isDefault: Boolean
  ) {
    createAddress(
      userId: $userId
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      state: $state
      country: $country
      postalCode: $postalCode
      isDefault: $isDefault
    ) {
      id
      userId
      addressLine1
      addressLine2
      city
      state
      country
      postalCode
      isDefault
    }
  }
`;
export const UPDATE_ADDRESS = gql`
  mutation UpdateAddress(
    $id: ID!
    $addressLine1: String
    $addressLine2: String
    $city: String
    $state: String
    $country: String
    $postalCode: String
    $isDefault: Boolean
  ) {
    updateAddress(
      id: $id
      addressLine1: $addressLine1
      addressLine2: $addressLine2
      city: $city
      state: $state
      country: $country
      postalCode: $postalCode
      isDefault: $isDefault
    ) {
      id
      addressLine1
      addressLine2
      city
      state
      country
      postalCode
      isDefault
    }
  }
`;
export const DELETE_ADDRESS = gql`
  mutation DeleteAddress($id: ID!) {
    deleteAddress(id: $id)
  }
`;


export const CREATE_ORDER_WITH_PAYMENT = gql`
 mutation CreateOrderWithPayment(
  $userId: ID!
  $totalAmount: Float!
  $status: String!
  $orderType: String
  $paymentGateway: String
  $transactionId: String
  $addressId: String!
  $items: [OrderItemInput!]!
) {
  createOrderWithPayment(
    userId: $userId
    totalAmount: $totalAmount
    status: $status
    orderType: $orderType
    paymentGateway: $paymentGateway
    transactionId: $transactionId
    addressId: $addressId
    items: $items
  ) {
    order {
      id
      status
      totalAmount
      createdAt
      orderType
      paymentYN
      items {
        id
        productId
        quantity
        price
      }
    }
    payment {
      id
      orderId
      userId
      paymentGateway
      transactionId
      status
      amount
      createdAt
    }
  }
}

`;